import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraIconButton } from '@mono/ui-components/ensigns';
import { SpecraCombobox, SpecraSegmentedControl } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { X } from 'lucide-react';
export function AwardScopeControl({ scope, facets, onChange }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsx(SpecraSegmentedControl, {
                label: "Awards",
                size: "sm",
                testId: Testids.registryGovOrg.awardScope,
                value: scope.preset,
                onValueChange: (preset)=>onChange({
                        ...scope,
                        preset
                    }),
                options: [
                    {
                        value: 'all',
                        label: 'All awards'
                    },
                    {
                        value: 'it',
                        label: 'IT services'
                    },
                    {
                        value: 'custom',
                        label: 'Codes…'
                    }
                ]
            }),
            scope.preset === 'custom' && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SpecraCombobox, {
                        label: "Add NAICS or PSC code",
                        placeholder: "Choose a code",
                        value: undefined,
                        onValueChange: (value)=>{
                            if (value && !scope.codes.includes(value)) onChange({
                                ...scope,
                                codes: [
                                    ...scope.codes,
                                    value
                                ]
                            });
                        },
                        options: facets.filter((f)=>!scope.codes.includes(`${f.kind}:${f.code}`)).map((f)=>({
                                value: `${f.kind}:${f.code}`,
                                label: `${f.kind} ${f.code}`,
                                description: `${f.description} · ${f.awardCount} awards`
                            }))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-wrap gap-2",
                        children: scope.codes.map((code)=>/*#__PURE__*/ _jsxs("span", {
                                children: [
                                    /*#__PURE__*/ _jsx(SpecraBadge, {
                                        variant: "neutral",
                                        children: code
                                    }),
                                    /*#__PURE__*/ _jsx(SpecraIconButton, {
                                        label: `Remove ${code}`,
                                        variant: "ghost",
                                        size: "sm",
                                        onClick: ()=>onChange({
                                                ...scope,
                                                codes: scope.codes.filter((c)=>c !== code)
                                            }),
                                        children: /*#__PURE__*/ _jsx(X, {})
                                    })
                                ]
                            }, code))
                    })
                ]
            })
        ]
    });
}
